import { useRef } from 'react';
import { Swiper as SwiperClass } from 'swiper/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { usePopup } from "../context/PopupContext";
import { popularDestinationsData } from '../data/popularDestinationData';
interface SlideProps {
    image: string;
    alt: string;
    imageText: string;
    cardTitle: string;
    additionalContent?: any;
    price?: number
}

interface SectionContentProps {
    sectionTitle: React.ReactNode;
    sectionSubtitle: string;
    sectionAnnotation: string;
    sectionId: string;
    buttonText?: string;
    items: SlideProps[];
}


const defaultSectionContent: SectionContentProps = {
    sectionSubtitle: "Discover",
    sectionTitle: "Turning Wanderlust Into Reality",
    sectionAnnotation: "Exceptional places, thoughtfully selected for every kind of journey.",
    buttonText: "Explore all destinations",
    sectionId: 'popularDestination',
    items: popularDestinationsData.map((item) => ({
        ...item,
        duration: item.duration || '',
        region: item.duration || '',
        location: item.location || '',
        additionalContent: item.additionalContent || null,
        price: undefined,
    })),
};


function toggleNavigation(swiper: SwiperClass) {
    const nextBtn = swiper?.navigation?.nextEl;
    const prevBtn = swiper?.navigation?.prevEl;

    if (Number(swiper.params.slidesPerView ?? 1)) {
        nextBtn.style.display = 'none';
        prevBtn.style.display = 'none';
    } else {
        nextBtn.style.display = '';
        prevBtn.style.display = '';
    }
}

export default function CardShowcaseSection({
    sectionData = defaultSectionContent }) {
    const swiperRef = useRef<SwiperClass | null>(null);
    const { openPopup } = usePopup();


    const renderCard = (slide: any) => {
        return slide.link ? (
            <a href={slide.link} className="card">
                <img src={slide.image} alt={slide.alt} loading='lazy' />
                <div className="card-label">
                    <p className="card-title">{slide.cardTitle}</p>
                    <p className="location">{slide.imageText}</p>
                </div>
                {slide.additionalContent && (
                    <div className="card-additional-content">{slide.additionalContent}</div>
                )}
                {slide.price && (
                    <p className="price">From £{slide.price?.toLocaleString('en-UK', { minimumFractionDigits: 0 })} p/week</p>
                )}
            </a>
        ) : (
            <div className="card" onClick={openPopup}>
                <img src={slide.image} alt={slide.alt} loading='lazy' />
                <div className="card-label">
                    <p className="card-title">{slide.cardTitle}</p>
                    <p className="location">{slide.imageText}</p>
                </div>
                {slide.additionalContent && (
                    <div className="card-additional-content">{slide.additionalContent}</div>
                )}
                {slide.price && (
                    <p className="price">From £{slide.price?.toLocaleString('en-UK', { minimumFractionDigits: 0 })} p/week</p>
                )}
            </div>
        )
    }

    return (
        <section className="popular-destinations" id={sectionData.sectionId}>
            <div className="container">
                <section>
                    <div className="text-content">
                        <p className="section-subtitle">{sectionData.sectionSubtitle}</p>
                        <h2 className="section-title">{sectionData.sectionTitle}</h2>
                        <p className="section-annotation left">
                            {sectionData.sectionAnnotation}
                        </p>

                        {sectionData.buttonText && (
                            <button className="section-cta cta" onClick={openPopup} type="button">{sectionData.buttonText}</button>
                        )}
                        {/* <button className="cta deskton" onClick={openPopup} type="button">{sectionData?.buttonText}Explore all destinations</button> */}
                    </div>

                    <div className="carousel-row">
                        <div className="popular-cards gopher">
                            <Swiper
                                className="popular-slider"
                                modules={[Navigation]}
                                spaceBetween={25}
                                slidesPerView="auto"
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                breakpoints={{
                                    992: { spaceBetween: 25 },
                                    768: { spaceBetween: 16 },
                                    480: { spaceBetween: 16 },
                                    320: { spaceBetween: 16 },
                                }}
                                onAfterInit={(swiper: SwiperClass) => {
                                    swiperRef.current = swiper;
                                    toggleNavigation(swiper);
                                }}
                                onResize={(swiper: SwiperClass) => {
                                    toggleNavigation(swiper);
                                }}
                            >
                                {sectionData.items.map((slide, index) => (
                                    <SwiperSlide key={index} className="swiper-slide">
                                        {renderCard(slide)}
                                    </SwiperSlide>
                                ))}

                                <div className="swiper-button swiper-button-prev">
                                    <svg width="10" height="18" viewBox="0 0 10 18">
                                        <path d="M1 1L9 9L1 17" stroke="currentColor" />
                                    </svg>
                                </div>
                                <div className="swiper-button swiper-button-next">
                                    <svg width="10" height="18" viewBox="0 0 10 18">
                                        <path d="M1 1L9 9L1 17" stroke="currentColor" />
                                    </svg>
                                </div>
                            </Swiper>
                        </div>
                    </div>

                    {sectionData.buttonText && (
                        <button className="section-cta cta" onClick={openPopup} type="button">{sectionData.buttonText}</button>
                    )}
                </section>
            </div>
        </section>
    );
}